package com.github.jangalinski.tabweb._foundation.size

data object LARGE : SmallToLargeX
